<app-content-box theme="white" borderRadius="base-border-radius">
  <div class="d-flex align-items-center gap-8">
    <i class="ri-search-line icon-sm2 c-t-blue-700"></i>
    <input
      class="full-width full-height"
      [(ngModel)]="search"
      (ngModelChange)="search$.next(search)"
    >
  </div>
</app-content-box>
